/* BEGIN Mid Nav helper */
/**
 * Nav located midway down the page, sticks when scrolled past.
 */
(function($) {
    var Mid_Nav = {
        config: {
            positionOffset: 0,
        },

        scrollPosition: 0,
        lastScrollPosition: 0,

        init: function( options ){
            let self = this;
            $.extend( this.config, options );

            $(document).ready(function() {
                self.initUI();
            });
        },

        initUI: function() {
            let self = this;

            if($('.mid-nav').length <= 0) {
                return this;
            }

            $(window).scroll(function(){
                self.scrollPosition = $(window).scrollTop();
                /**
                 * Page is scrolled below top of mid-nav, clone mid-nav
                 * and apply #fixed-nav ID (sticky styles)
                 */
                if($('.mid-nav').offset().top - self.scrollPosition <= self.config.positionOffset && !$('#fixed-nav').length && self.scrollPosition > self.lastScrollPosition){
                    let clonedNav = $('.mid-nav').clone();
                    clonedNav.attr('id', 'fixed-nav');
                    $('#app').append(clonedNav);
                }
                else if($('.mid-nav').offset().top - $(window).scrollTop() > self.config.positionOffset && self.scrollPosition < self.lastScrollPosition){
                    // Destroy cloned mid-nav element
                    $('#fixed-nav').remove();
                }
                self.lastScrollPosition = self.scrollPosition;
            });

            return this;
        }
    }.init();
})(jQuery);
/* End Mid Nav helper */